import Flex from 'components/ui/Flex';
import styled from 'styled-components';
import { ScannerConfig } from './scannerActions';
import QRCode from 'react-qr-code';
import Barcode from 'react-barcode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import Text from 'components/ui/Text';
import { useTranslation } from 'react-i18next';
import useDisplayFormat from 'hooks/useDisplayFormat';
type ScannerPendingCardProps = {
    scannerConfig: ScannerConfig;
};

const ScannerPendingCard = ({ scannerConfig }: ScannerPendingCardProps) => {
    const { t } = useTranslation();
    const { format } = useDisplayFormat();
    const encodedValue = JSON.stringify(scannerConfig.scannerValue);

    return (
        <Wrapper column align="center">
            <Flex gap="0.5rem" align="center" className="w-100">
                <FontAwesomeIcon icon={faCircleInfo} size="1x" color="#0011ff" />
                <Label>{t('scannerCodeLabel', { label: t(`${scannerConfig.labelKey}`) })}</Label>
            </Flex>
            <StyledText>{t('scannerScanAgainConfirm')}</StyledText>

            <Flex column align="center" gap="0.75rem" className="qr-image">
                {format === 'qrcode' ? (
                    <QRCode value={encodedValue} size={140} />
                ) : (
                    <BarcodeWrapper>
                        <Barcode
                            value={encodedValue}
                            height={60}
                            fontSize={11}
                            margin={0}
                            text={t(`${scannerConfig.labelKey}`)}
                        />
                    </BarcodeWrapper>
                )}
            </Flex>
        </Wrapper>
    );
};

export default ScannerPendingCard;

const Wrapper = styled(Flex)`
    padding: 1rem;
    border-radius: var(--radius);
`;

const Label = styled.label`
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.25rem;
    font-weight: 700;
    margin-top: 0;
`;

const StyledText = styled(Text)`
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.text};
`;

const BarcodeWrapper = styled.div`
    width: 100%;
    svg {
        width: 100% !important;
        height: auto !important;
    }
    @media print {
        width: 40vmin;
    }
`;
